import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";

export default function Table({ collection, importType }) {
  const conditionalRowStyles = [
    {
      when: (row) => {
        if (['finch_manual', 'finch_automatic'].includes(importType)) {
          return row.attributes.validation_errors.length > 0;
        }

        return row.attributes.item_status == "T";
      },
      style: {
        backgroundColor: "red",
        color: "white",
      },
    },
  ];

  const columns = [
    {
      name: "Record#",
      selector: "attributes.position",
      sortable: true,
    },
    {
      name: "Item Status",
      selector: "attributes.item_status",
      width: "150px",
      sortable: true,
    },
    {
      name: "First Name",
      selector: "attributes.first_name",
      sortable: true,
      sortFunction: (a, b) =>
        a.attributes.created_at_int - b.attributes.created_at_int,
    },
    {
      name: "Last Name",
      selector: "attributes.last_name",
      sortable: true,
    },
    {
      name: "Email",
      selector: "attributes.email",
      sortable: true,
    },
    {
      name: "Errors",
      sortable: false,
      cell: (row) => (
        <ul className="list-unstyled">
          {row.attributes.validation_errors.split(",").map((item) => (
            <li>{item}</li>
          ))}
        </ul>
      ),
    },
  ];

  return (
    <>
      <DataTable
        title=""
        columns={columns}
        data={collection}
        noDataComponent="No records were processed"
        persistTableHead={true}
        conditionalRowStyles={conditionalRowStyles}
        pagination
        paginationComponentOptions={{
          selectAllRowsItem: true,
          selectAllRowsItemText: "All",
        }}
      />
    </>
  );
}
